export const ColorConstants = {
    grey: "#606060",
    grey1:"#626262",
    light_blue: "#337ab7",
    green: "#88c656",
    sidemenu_green: "#88c656",
    sidemenu_light_grey: "#00000080",
    brand_light_blue: "#0973ba",
    white:"#fff",
    orange_500:"#d36d13",
    brand_primary_blue_1: "#05386b",
    brand_primary_blue_2: "#0973ba",   
    button_black:"#rgba(0, 0, 0, 0.68)",
    navy_blue:"#011120",
    grey_disabled:"#939393",
    black:"#000000",
    grey_placeholder: "#898d91",
    "$success-500": "#1F8747",
    "$error-600": "#b8433c",
    "$theme-warning": "#D69F38",
    "$sapphire": "#0973BA",
     white_90: "#ffffffcc",
};
